
























































import {
  computed,
  defineComponent,
  ref,
  Ref,
} from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';
import { useRouter } from '@ideavivat/vivat-2';

import account from '@/table/setting/account';

import getPaymentAccounts from '@/gql/paymentAccount/getPaymentAccounts.gql';
import deletePaymentAccount from '@/gql/paymentAccount/deletePaymentAccount.gql';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonFormWithPaymentAccountEditor from '@/components/Setting/CommonFormWithPaymentAccountEditor.vue';

const Account = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonFormWithPaymentAccountEditor,
  },
  setup() {
    const { route } = useRouter();
    const searchPaymentAccount: Ref<string> = ref('');
    const searchPaymentAccountCode: Ref<string> = ref('');
    const getAccountsResult = (data: any) => data.paymentAccounts;
    // ==== Use to search User ==== //
    const getAccountsVariables = computed(() => {
      const vars: {[key: string]: any} = {
        filterName: undefined,
        filterCode: undefined,
        filterCashFlowCategory: parseInt(route.value.params.id, 10),
      };
      if (searchPaymentAccount.value) {
        vars.filterName = `%${searchPaymentAccount.value}%`;
      }
      if (searchPaymentAccountCode.value) {
        vars.filterCode = `%${searchPaymentAccountCode.value}%`;
      }
      return vars;
    });
    const addAccountModal = ref(null);
    const editAccountId = ref(-1);

    // =============================================
    // ===== Use to delete Account from system =====
    // =============================================
    const deleteAccountModal = ref(null);
    const deletePaymentAccountMutation = useMutation(deletePaymentAccount, {
      refetchQueries: ['getAccounts'],
    });
    function deletePaymentAccountAction(accountId: number) {
      deletePaymentAccountMutation.mutate({
        id: accountId,
      });
    }

    return {
      searchPaymentAccount,
      searchPaymentAccountCode,
      getAccountsResult,
      getAccountsVariables,
      getAccountsQuery: getPaymentAccounts,
      accountsTableOptions: account,

      addAccountModal,
      editAccountId,
      deleteAccountModal,
      deletePaymentAccountAction,
    };
  },
});

export default Account;
